import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WalmSite from './WalmSite/WalmSite';

// Walm Innovations website. Pages are authored in walm-site-v2/ and compiled
// into src/WalmSite/pages.js by scripts/build-walm-site.py.
const WALM_ROUTES = [
  '/',
  '/guide',
  '/team',
  '/case-studies/gmm-pfaudler',
  '/case-studies/epigral',
  '/case-studies/mass-balance',
];

export default function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {WALM_ROUTES.map((path) => (
            <Route key={path} path={path} element={<WalmSite page={path} />} />
          ))}
        </Routes>
      </Router>
    </div>
  );
}
